var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTable',_vm._g({attrs:{"storage-id":_vm.storageId,"source-columns":_vm.columns,"rows":_vm.rows,"is-loading":_vm.isLoading,"pagination":{ 'page-index': _vm.page, 'page-size': _vm.pageSize },"total":_vm.total}},_vm.paginationListeners))}
var staticRenderFns = []

export { render, staticRenderFns }